import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '重要规则',
    type: 'RULEMRMRULE_1',
}
